import { PUD_CLASS_OPTIONS } from './constants';

type PUDInformationFieldsOptions = {
  handleChange: (field: string, value: unknown) => void;
};

export const getPUDInformationFields = ({
  handleChange,
}: PUDInformationFieldsOptions) => [
  {
    type: 'text',
    name: 'condoProjectName',
    label: 'Project Name',
    dataTestId: 'pudProjectName',
    placeholder: 'Project Name',
    span: 2,
  },
  {
    type: 'text',
    name: 'cpmProjectId',
    label: 'CPM Project ID',
    dataTestId: 'pudCpmProjectId',
    placeholder: 'CPM Project ID',
    span: 2,
  },
  {
    type: 'select',
    name: 'pudClass',
    label: 'PUD Class',
    dataTestId: 'pudClass',
    options: PUD_CLASS_OPTIONS,
    onChangeHandler: (value) => handleChange('pudClass', value),
    span: 2,
  },
  {
    type: 'text',
    name: 'hoaTaxId',
    label: 'HOA Tax ID #',
    dataTestId: 'pudTaxId',
    placeholder: 'HOA Tax ID #',
    span: 2,
    rules: {
      validate: (value: string) => {
        if (!value) return true;
        return (
          (value.length >= 9 && value.length <= 10) ||
          'HOA Tax ID # must be 9-10 characters'
        );
      },
    },
  },
];
